import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Self-hosted fonts (DSGVO-konform) – nur Latin-Subset, spart mehrere Font-Requests
import "@fontsource/space-grotesk/latin-400.css";
import "@fontsource/space-grotesk/latin-600.css";
import "@fontsource/space-grotesk/latin-700.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// WebMCP-Tools für KI-Agenten registrieren – erst wenn die Seite steht,
// damit der Start nicht durch eine zusätzliche Anfrage verzögert wird
const loadWebMcp = () => {
  import("./lib/webmcp").then(({ registerWebMcpTools }) => registerWebMcpTools());
};
const w = window as Window & {
  requestIdleCallback?: (cb: () => void) => number;
  navigator: Navigator & { modelContext?: unknown };
};
const scheduleWebMcp = () =>
  w.requestIdleCallback ? w.requestIdleCallback(loadWebMcp) : window.setTimeout(loadWebMcp, 2500);
// Agenten-Umgebungen (WebMCP vorhanden) sofort bedienen, sonst erst im Leerlauf laden.
if (w.navigator.modelContext) loadWebMcp();
else if (document.readyState === "complete") scheduleWebMcp();
else window.addEventListener("load", scheduleWebMcp, { once: true });

